import { AppUser } from 'Src/views/App/App';
import { getSchoolModules } from 'Src/helpers/service/admin/schoolModules';

export type ModuleStatus = 'ACTIVE' | 'INACTIVE' | 'TRIAL';

export interface ModuleSubscriptionLite {
  module: string;
  status: ModuleStatus;
  validFrom?: string | Date | null;
  validUntil?: string | Date | null;
}

export function isModuleSubscriptionActive(sub?: ModuleSubscriptionLite): boolean {
  if (!sub) return false;
  if (sub.status === 'INACTIVE') return false;

  const now = new Date();

  if (sub.validFrom) {
    const from = new Date(sub.validFrom as string);
    if (!isNaN(from.getTime()) && from > now) return false;
  }

  if (sub.validUntil) {
    const until = new Date(sub.validUntil as string);
    if (!isNaN(until.getTime()) && until < now) return false;
  }

  return true;
}

/**
 * Sync check — reads from cached user.activeSchool.moduleSubscriptions.
 * Fast but may be stale if modules were changed after login.
 */
export function isModuleActive(user: AppUser, module: string): boolean {
  const subs: ModuleSubscriptionLite[] = (user?.activeSchool as any)?.moduleSubscriptions ?? [];

  const sub = subs.find(s => s.module === module);
  return isModuleSubscriptionActive(sub);
}

/**
 * Async check — always fetches fresh data from the server.
 * Use this before showing UI that depends on module status.
 */
export async function isModuleActiveFresh(user: AppUser, module: string): Promise<boolean> {
  try {
    const subs = await getSchoolModules(user);
    const sub = subs.find(s => s.module === module);
    return isModuleSubscriptionActive(sub as ModuleSubscriptionLite);
  } catch {
    // Fall back to cached value on network error
    return isModuleActive(user, module);
  }
}
